import Vue from 'vue';
import Vuetify from 'vuetify/lib';

import i18n from '@/i18n';

import IconLine from '@/components/icons/IconLine.vue';
import IconFixRow from '@/components/icons/IconFixRow.vue';
import IconAddData from '@/components/icons/IconAddData.vue';
import IconSettingsReport from '@/components/icons/IconSettingsReport.vue';
import IconEditLine from '@/components/icons/IconEditLine.vue';
import IconCopyQuickPaste from '@/components/icons/IconCopyQuickPaste.vue';
import IconQuickGuide from '@/components/icons/IconQuickGuide.vue';


Vue.use(Vuetify);

export default new Vuetify({
    lang: {
        t: (key: string, ...params: Array<string | number>): string => i18n.t(key, params) as any,
    },
    icons: {
        iconfont: 'mdi',
        values: {
            line: {
                component: IconLine,
            },
            fixRow: {
                component: IconFixRow,
            },
            addData: {
                component: IconAddData,
            },
            settingsReport: {
                component: IconSettingsReport,
            },
            editLine: {
                component: IconEditLine,
            },
            copyQuickPaste: {
                component: IconCopyQuickPaste,
            },
            quickGuide: {
                component: IconQuickGuide,
            },
        },
    },
});
